ListComponent = require 'views/enterprise/dashboard/list-component'
SearchComponent = require 'views/enterprise/dashboard/search-component'
React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_popover')
_ = require('underscore')

COLLAPSED_LIST_LENGTH = 10

module.exports = class extends React.Component
  constructor: (props) ->
    super(props)

    allItems = _.reduce _.values(@props.items), (memo, groupItems) ->
      memo.concat(groupItems)
    , []

    @state = {
      isCollapsed: true
      allItems: allItems
      searchMatches: allItems
    }

  onSearchTermChange: (term) ->
    @setState searchMatches: _.filter @state.allItems, (item) ->
      item.isSearchMatch(term)

  paginate: (groupItems) ->
    groupSearchMatches = _.filter groupItems, (item) =>
      item in @state.searchMatches

    groupsWithItems = _.filter _.values(@props.items), (items) ->
      items.length > 0

    if @state.isCollapsed
      _.first(groupSearchMatches, COLLAPSED_LIST_LENGTH / groupsWithItems.length)
    else
      groupSearchMatches

  render: t.renderable ->
    t.div '.enterprise-pop-over', =>
      if @state.allItems.length > COLLAPSED_LIST_LENGTH
        t.addElement React.createElement SearchComponent,
          onChange: _.debounce(@onSearchTermChange, 300)
          placeholder: t.l(['search', @props.modelName])

      if @props.buttonData?
        t.addElement React.createElement @props.buttonData.componentClass,
          onClick: @props.buttonData.onClick

      for group, items of @props.items when items.length > 0
        t.div =>
          t.h3 '.popover-group-header', ->
            t.format group

          t.addElement React.createElement ListComponent,
            items: @paginate(items)
            itemComponent: @props.itemComponent
            itemEventHandlers: @props.itemEventHandlers
            itemInlineButtons: @props.itemInlineButtons
            isPopOver: true

      return unless @state.searchMatches.length > COLLAPSED_LIST_LENGTH

      t.div =>
        t.a '.quiet-button',
          href: "#"
          style: { marginTop: '8px' }
          onClick: =>
            @setState(isCollapsed: !@state.isCollapsed)
        , =>
          t.span =>
            if @state.isCollapsed
              t.format ['show-other', @props.modelName]
            else
              t.format ['hide-other', @props.modelName]




// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/group-list-popover-component.coffee